<template>
  <ContentWrap>
    <el-form :inline="true" :model="query" class="-mb-15px" @submit.prevent>
      <el-form-item label="动态内容"
        ><el-input
          v-model="query.keyword"
          clearable
          class="!w-220px"
          placeholder="请输入动态内容"
          @keyup.enter="search"
      /></el-form-item>
      <el-form-item label="用户昵称"
        ><el-input
          v-model="query.userNickname"
          clearable
          class="!w-180px"
          placeholder="请输入用户昵称"
          @keyup.enter="search"
      /></el-form-item>
      <el-form-item label="发布时间"
        ><el-date-picker
          v-model="publishRange"
          type="datetimerange"
          value-format="YYYY-MM-DD HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          class="!w-360px"
      /></el-form-item>
      <el-form-item
        ><el-button type="primary" @click="search"
          ><Icon class="mr-5px" icon="ep:search" />查询</el-button
        ><el-button @click="reset"
          ><Icon class="mr-5px" icon="ep:refresh" />重置</el-button
        ></el-form-item
      >
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-tabs v-model="query.auditStatus" @tab-change="changeTab">
      <el-tab-pane :label="`待审核 ${counts[0]}`" :name="0" />
      <el-tab-pane :label="`已通过 ${counts[1]}`" :name="1" />
      <el-tab-pane :label="`已驳回 ${counts[2]}`" :name="2" />
    </el-tabs>
    <div class="mb-12px">
      <el-button
        v-hasPermi="['bosscircle:feed:audit']"
        type="success"
        plain
        :disabled="!selectedRows.length"
        @click="batchAudit(1)"
        ><Icon class="mr-5px" icon="ep:circle-check" />批量通过</el-button
      >
      <el-button
        v-hasPermi="['bosscircle:feed:audit']"
        type="danger"
        plain
        :disabled="!selectedRows.length"
        @click="batchAudit(2)"
        ><Icon class="mr-5px" icon="ep:circle-close" />批量驳回</el-button
      >
      <el-button
        v-hasPermi="['bosscircle:feed:delete']"
        type="danger"
        plain
        :disabled="!selectedRows.length"
        @click="deleteSelected"
        ><Icon class="mr-5px" icon="ep:delete" />批量删除</el-button
      >
      <span v-if="selectedRows.length" class="ml-10px text-12px text-#909399"
        >已选择 {{ selectedRows.length }} 项</span
      >
    </div>
    <el-table
      v-loading="loading"
      :data="list"
      row-key="id"
      @selection-change="selectedRows = $event"
    >
      <el-table-column type="selection" width="45" />
      <el-table-column label="用户昵称" min-width="150"
        ><template #default="{ row }"
          ><div class="flex items-center gap-8px"
            ><el-avatar :src="row.userAvatar || undefined" :size="32"
              ><Icon icon="ep:user-filled" /></el-avatar
            ><span>{{ row.userNickname || '-' }}</span></div
          ></template
        ></el-table-column
      >
      <el-table-column prop="content" label="动态内容" min-width="260" show-overflow-tooltip />
      <el-table-column prop="locationName" label="位置" min-width="120" show-overflow-tooltip />
      <el-table-column prop="likeCount" label="点赞" width="70" />
      <el-table-column prop="commentCount" label="评论" width="70" />
      <el-table-column label="审核状态" width="100"
        ><template #default="{ row }"
          ><el-tag
            :type="row.auditStatus === 1 ? 'success' : row.auditStatus === 2 ? 'danger' : 'warning'"
            >{{ auditText(row.auditStatus) }}</el-tag
          ></template
        ></el-table-column
      >
      <el-table-column prop="createTime" label="发布时间" width="180" :formatter="dateFormatter" />
      <el-table-column label="操作" width="180" fixed="right"
        ><template #default="{ row }"
          ><el-button link type="primary" @click="openDetail(row)">详情</el-button
          ><el-button
            v-if="row.auditStatus === 0"
            v-hasPermi="['bosscircle:feed:audit']"
            link
            type="warning"
            @click="openAudit(row)"
            >审核</el-button
          ><el-button
            v-hasPermi="['bosscircle:feed:delete']"
            link
            type="danger"
            @click="deleteOne(row.id)"
            >删除</el-button
          ></template
        ></el-table-column
      >
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>

  <Dialog
    v-model="detailVisible"
    :title="auditMode ? '动态审核' : '动态详情'"
    width="760px"
  >
    <div v-if="detail" class="feed-detail">
      <el-descriptions :column="2" border class="feed-detail__summary" label-width="88px">
        <el-descriptions-item label="用户昵称">{{
          detail.userNickname || '-'
        }}</el-descriptions-item>
        <el-descriptions-item label="发布时间">{{
          formatDate(detail.createTime)
        }}</el-descriptions-item>
        <el-descriptions-item label="审核状态"
          ><el-tag
            :type="
              detail.auditStatus === 1 ? 'success' : detail.auditStatus === 2 ? 'danger' : 'warning'
            "
            size="small"
            >{{ auditText(detail.auditStatus) }}</el-tag
          ></el-descriptions-item
        >
        <el-descriptions-item label="显示状态"
          ><el-tag :type="detail.status === 1 ? 'success' : 'info'" size="small">{{
            detail.status === 1 ? '正常' : '隐藏'
          }}</el-tag></el-descriptions-item
        >
        <el-descriptions-item label="发布位置">{{
          detail.locationName || '-'
        }}</el-descriptions-item>
        <el-descriptions-item label="审核备注">{{
          detail.auditRemark || '-'
        }}</el-descriptions-item>
      </el-descriptions>

      <section class="feed-detail__section">
        <div class="feed-detail__heading">互动数据</div>
        <div class="feed-detail__metrics">
          <div
            ><strong>{{ detail.likeCount || 0 }}</strong
            ><span>点赞</span></div
          >
          <div
            ><strong>{{ detail.commentCount || 0 }}</strong
            ><span>评论</span></div
          >
          <div
            ><strong>{{ detail.shareCount || 0 }}</strong
            ><span>分享</span></div
          >
          <div
            ><strong>{{ detail.viewCount || 0 }}</strong
            ><span>浏览</span></div
          >
        </div>
      </section>

      <section class="feed-detail__section">
        <div class="feed-detail__heading">动态内容</div>
        <div class="feed-detail__content">{{ detail.content || '-' }}</div>
      </section>

      <section class="feed-detail__section">
        <div class="feed-detail__heading">动态图片</div>
        <div v-if="detail.images?.length" class="feed-detail__images">
          <el-image
            v-for="image in detail.images"
            :key="image"
            :src="image"
            :preview-src-list="detail.images"
            fit="cover"
          />
        </div>
        <div v-else class="feed-detail__empty">暂无图片</div>
      </section>

      <template v-if="auditMode && detail.auditStatus === 0">
        <el-divider content-position="left">审核操作</el-divider>
        <el-form label-width="96px">
          <el-form-item label="审核结果">
            <el-radio-group v-model="auditForm.pass">
              <el-radio :value="true">通过</el-radio>
              <el-radio :value="false">驳回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="!auditForm.pass" label="驳回原因" required>
            <el-input
              v-model="auditForm.remark"
              type="textarea"
              :rows="3"
              maxlength="200"
              show-word-limit
              placeholder="请填写驳回原因"
            />
          </el-form-item>
        </el-form>
      </template>
    </div>
    <template #footer>
      <el-button @click="detailVisible = false">关闭</el-button>
      <el-button
        v-if="auditMode && detail?.auditStatus === 0"
        type="primary"
        :loading="auditForm.saving"
        @click="submitAudit"
        >提交审核</el-button
      >
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import * as Api from '@/api/business/feed'
import { dateFormatter, formatDate } from '@/utils/formatTime'
defineOptions({ name: 'BossCircleFeed' })
const message = useMessage(),
  loading = ref(false),
  list = ref<Api.FeedVO[]>([]),
  selectedRows = ref<Api.FeedVO[]>([]),
  total = ref(0),
  counts = reactive<Record<number, number>>({ 0: 0, 1: 0, 2: 0 }),
  publishRange = ref<string[]>([]),
  detailVisible = ref(false),
  auditMode = ref(false),
  detail = ref<Api.FeedVO>()
const auditForm = reactive({ pass: true, remark: '', saving: false })
const query = reactive({ pageNo: 1, pageSize: 10, auditStatus: 0, keyword: '', userNickname: '' })
const load = async () => {
  loading.value = true
  try {
    const data = await Api.getFeedPage({
      ...query,
      createTimeStart: publishRange.value?.[0],
      createTimeEnd: publishRange.value?.[1]
    })
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}
const loadCounts = async () => Object.assign(counts, await Api.getAuditCounts())
const search = () => {
  query.pageNo = 1
  load()
}
const reset = () => {
  query.pageNo = 1
  query.keyword = ''
  query.userNickname = ''
  publishRange.value = []
  load()
}
const changeTab = (name: string | number) => {
  query.auditStatus = Number(name)
  query.pageNo = 1
  load()
}
const auditText = (status: number) => ['待审核', '已通过', '已驳回'][status] || '-'
const getRemark = async (status: number, count?: number) => {
  if (status === 2)
    return (await message.prompt('请输入驳回原因', count ? `批量驳回 ${count} 条动态` : '驳回动态'))
      .value
  await message.confirm(count ? `确认批量通过选中的 ${count} 条动态吗？` : '确认通过该动态吗？')
  return undefined
}
const batchAudit = async (status: number) => {
  const ids = selectedRows.value.map((v) => v.id)
  if (!ids.length) return
  const remark = await getRemark(status, ids.length)
  await Api.batchAuditFeed(ids, status, remark)
  selectedRows.value = []
  message.success('批量审核成功')
  await Promise.all([load(), loadCounts()])
}
const openAudit = (row: Api.FeedVO) => {
  detail.value = row
  auditMode.value = true
  auditForm.pass = true
  auditForm.remark = ''
  detailVisible.value = true
}
const submitAudit = async () => {
  if (!detail.value?.id) return
  if (!auditForm.pass && !auditForm.remark.trim()) {
    message.warning('请填写驳回原因')
    return
  }
  auditForm.saving = true
  try {
    await Api.auditFeed(
      detail.value.id,
      auditForm.pass ? 1 : 2,
      auditForm.pass ? undefined : auditForm.remark.trim()
    )
    message.success(auditForm.pass ? '已通过' : '已驳回')
    detailVisible.value = false
    await Promise.all([load(), loadCounts()])
  } finally {
    auditForm.saving = false
  }
}
const deleteOne = async (id: number) => {
  await message.delConfirm('确认删除该动态吗？')
  await Api.deleteFeed(id)
  message.success('删除成功')
  await Promise.all([load(), loadCounts()])
}
const deleteSelected = async () => {
  await message.delConfirm(`确认删除选中的 ${selectedRows.value.length} 条动态吗？`)
  await Api.deleteFeedList(selectedRows.value.map((v) => v.id))
  selectedRows.value = []
  message.success('批量删除成功')
  await Promise.all([load(), loadCounts()])
}
const openDetail = (row: Api.FeedVO) => {
  detail.value = row
  auditMode.value = false
  detailVisible.value = true
}
onMounted(() => Promise.all([load(), loadCounts()]))
</script>

<style scoped lang="scss">
.feed-detail {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.feed-detail__summary :deep(.el-descriptions__label) {
  color: #606266;
  font-weight: 600;
}
.feed-detail__section {
  padding-top: 2px;
}
.feed-detail__heading {
  margin-bottom: 10px;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}
.feed-detail__metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border: 1px solid #ebeef5;
  background: #fafafa;
}
.feed-detail__metrics > div {
  display: flex;
  min-height: 64px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-right: 1px solid #ebeef5;
}
.feed-detail__metrics > div:last-child {
  border-right: 0;
}
.feed-detail__metrics strong {
  color: #303133;
  font-size: 18px;
}
.feed-detail__metrics span,
.feed-detail__empty {
  color: #909399;
  font-size: 13px;
}
.feed-detail__content {
  min-height: 48px;
  padding: 12px 14px;
  border: 1px solid #ebeef5;
  background: #fafafa;
  color: #303133;
  line-height: 1.7;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}
.feed-detail__images {
  display: grid;
  grid-template-columns: repeat(auto-fill, 112px);
  gap: 10px;
}
.feed-detail__images :deep(.el-image) {
  width: 112px;
  height: 112px;
  border: 1px solid #ebeef5;
  background: #f5f7fa;
}
.feed-detail__empty {
  padding: 18px 0;
  border: 1px dashed #dcdfe6;
  text-align: center;
}
@media (max-width: 640px) {
  .feed-detail__metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .feed-detail__metrics > div:nth-child(2) {
    border-right: 0;
  }
  .feed-detail__metrics > div:nth-child(-n + 2) {
    border-bottom: 1px solid #ebeef5;
  }
}
</style>
